export const useCurrentUser = (): any => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") as string)
    const ownerInfo = JSON.parse(localStorage.getItem("ownerInfo") as string)
    const tenantInfo = JSON.parse(localStorage.getItem("tenantInfo") as string)
    return [userInfo, userInfo.id, ownerInfo, tenantInfo]
  } catch {
    return [null, null]
  }
}
